import {observable, action} from 'mobx'
import {ownRequest} from '../api/ownFetch';
import notificationsStore from './NotificationsStore';
import localizationStore from './LocalizationStore';

class Task {
    constructor(task, parent) {
        this.id = task.id
        this.description = task.description
        this.parentAgent = parent
    }

    id = null
    parentAgent = null

    @observable
    description = ''

    @action
    setDescription(d) {
        this.changeDescriptionRequest(d)
    }

    async loadTaskConfigurationRequest () {
        const response = await ownRequest(
            'GET',
            `/agentdata/${this.parentAgent.id}/agenttasks/${this.id}/configuration`
        )
        if (response.status === 200){
            return response.json()
        }
        return Promise.reject()
    }

    async changeDescriptionRequest (agentId, newName) {
        let response = await ownRequest(
            'PUT',
            '/agentdata/' + this.parentAgent.id + '/agenttasks/' + this.id,
            undefined, // acceptType
            undefined, // params
            {agentTask: {description: newName.trim()}} // body
        )
        switch (response.status){
            case 200: {
                this.description = newName
                notificationsStore.pushNotification(localizationStore.locale.task_name_changed)
                return Promise.resolve()
            }
            default: {
                notificationsStore.pushNotification(localizationStore.locale.unknown_error)
                return Promise.reject()
            }
        }
    }

    editTaskConfigurationRequest(agentTask) {
        console.log(agentTask)
        return ownRequest(
            'PUT',
            `/agentdata/${this.parentAgent.id}/agenttasks/${this.id}/configuration`,
            undefined, // acceptType
            undefined, // params
            {agentTask: agentTask} // body
        ).then((response) => {
            if (response.ok) {
                return response.json()
            } else {
                return Promise.reject(response)
            }
        }).then((data) => {
            try {
                this.description = data.agentTask.description
                notificationsStore.pushNotification(localizationStore.locale.task_configuration_updated)
            } catch (e) {
                console.error('Wrong response data format')
            }
        }).catch(response => {
            notificationsStore.pushNotification(response.headers.get('x-uberblik-error'))
            return Promise.reject()
        })
    }

}

export default Task;


// WEBPACK FOOTER //
// ./src/store/Task.js